<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="pageComissoes.content"
                dataKey="movimentoId"
                [rows]="pageComissoes.size"
                [paginator]="true"
                [totalRecords]="pageComissoes.totalElements"
                [lazy]="true"
                [loading]="loading"
                [rowHover]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [showCurrentPageReport]="true"
                styleClass="p-datatable-gridlines"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row">
                            <div class="p-fluid sm:w-12rem sm:mr-2">
                                <label htmlFor="filtroData">Inicial</label>
                                <p-calendar
                                    dateFormat="dd/mm/yy"
                                    placeholder="Selecione"
                                    [showIcon]="true"
                                    [readonlyInput]="true"
                                    [(ngModel)]="filtroDataInicio"
                                    (ngModelChange)="alterarFiltro(dt1)"
                                    appendTo="body"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid sm:w-12rem sm:mr-2">
                                <label htmlFor="filtroData">Final</label>
                                <p-calendar
                                    dateFormat="dd/mm/yy"
                                    placeholder="Selecione"
                                    [showIcon]="true"
                                    [readonlyInput]="true"
                                    [(ngModel)]="filtroDataFim"
                                    (ngModelChange)="alterarFiltro(dt1)"
                                    appendTo="body"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid sm:mr-2">
                                <label>Tipo</label>
                                <p-dropdown
                                    [options]="listaTiposComissao"
                                    placeholder="Selecione"
                                    optionLabel="label"
                                    optionValue="value"
                                    name="filtroTipo"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="tipoComissaoSelecionado"
                                    (onChange)="alterarFiltro(dt1)"
                                >
                                    c
                                </p-dropdown>
                            </div>
                            <div class="p-fluid sm:mr-2">
                                <label>Contrato</label>
                                <p-dropdown
                                    [options]="listaEquipes"
                                    placeholder="Selecione"
                                    optionLabel="label"
                                    optionValue="value"
                                    name="filtroTipo"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="equipeSelecionada"
                                    (onChange)="alterarFiltro(dt1)"
                                ></p-dropdown>
                            </div>
                            <div class="p-fluid sm:mr-2">
                                <label>Profissional</label>
                                <p-dropdown
                                    [options]="listaProfissionais"
                                    placeholder="Selecione"
                                    optionLabel="label"
                                    optionValue="value"
                                    name="filtroTipo"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="profissionalSelecionado"
                                    (onChange)="alterarFiltro(dt1)"
                                ></p-dropdown>
                            </div>
                            <button
                                pButton
                                pRipple
                                [icon]="
                                    loadingRelatorio ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'
                                "
                                [disabled]="loadingRelatorio || pageComissoes.content.length === 0"
                                pTooltip="Obter relatório"
                                class="p-button-outlined h-auto mt-4"
                                (click)="obterRelatorio()"
                            ></button>
                        </div>

                        <div class="p-fluid mt-2 sm:mt-4">
                            <div class="flex">
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>Data Caixa</th>
                        <th>Comanda</th>
                        <th>Cliente</th>
                        <th>Profissional</th>
                        <th>Descrição</th>
                        <th>Quantidade</th>
                        <th>Total</th>
                        <th>%</th>
                        <th>Líquido</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.dataMovimento | date: "dd/MM/yyyy" }}
                        </td>
                        <td>
                            {{ item.controle.toString().padStart(7, "0") }}
                        </td>
                        <td>
                            {{ item.nomeCliente }}
                        </td>
                        <td>
                            {{ item.nomeProfissional }}
                        </td>
                        <td>
                            {{ item.descricaoItem }}
                        </td>
                        <td>
                            {{ item.quantidade }}
                        </td>
                        <td>
                            {{ item.totalVenda | currency: "BRL" }}
                        </td>
                        <td>
                            {{ item.comissao / 100 | percent: "1.2-2" }}
                        </td>
                        <td>
                            {{ item.valorComissao | currency: "BRL" }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="9">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="9">Carregando. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
